const APP = {
  languagues: ['fr', 'nl', 'en'],
}

export default Object.freeze(APP)
